var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authenticated)?_c('a',{staticClass:"logout-button-component",attrs:{"href":_vm.redirect},on:{"click":_vm.logout}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }